import { useBookingCommerceStore } from '@/stores/bookingCommerce'
import { useBookingSelectionsStore } from '@/stores/bookingSelections'
import { useCartStore } from '@/stores/cart'
import { useCheckoutStore } from '@/stores/checkout'
import { useContentStore } from '@/stores/content'
import { useMainStore } from '@/stores/main'
import { storeId } from '@/stores/storeId'

export function resetStores() {
  Object.values(storeId).forEach((key) => localStorage.removeItem(key))
  useMainStore().$reset()
  useBookingSelectionsStore().$reset()
  useCartStore().$reset()
  useCheckoutStore().$reset()
  useBookingCommerceStore().$reset()
  useContentStore().$reset()
}
